// extracted by mini-css-extract-plugin
export default {"footer":"footer-component_footer__q8kuf","imageWrapper":"footer-component_imageWrapper__aUqW9"};